import { recordFromSnapshot } from 'utils/firebaseUtils'
import { INIT_MEMBER } from './currentMember'

// import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_MEMBER_ERROR = 'CREATE_MEMBER_ERROR'
export const CREATE_MEMBER_SUCCESS = 'CREATE_MEMBER_SUCCESS'
export const DELETE_MEMBER_ERROR = 'DELETE_MEMBER_ERROR'
export const DELETE_MEMBER_SUCCESS = 'DELETE_MEMBER_SUCCESS'
export const UPDATE_MEMBER_ERROR = 'UPDATE_MEMBER_ERROR'
export const UPDATE_MEMBER_SUCCESS = 'UPDATE_MEMBER_SUCCESS'
export const SELECT_MEMBER = 'SELECT_MEMBER'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectMember(member) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_MEMBER,
      payload: member
    })
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createMember(member) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    member.id = member.firstname.toLowerCase() + member.lastname.toLowerCase()
    firebase.child('members').push(member, error => {
      if (error) {
        console.error('ERROR @ createMEMBER :', error)
        dispatch({
          type: CREATE_MEMBER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteMember(member) {
  return (dispatch, getState) => {
    const { firebase } = getState()

    firebase.child(`members/${member.key}`).remove(error => {
      if (error) {
        console.error('ERROR @ deleteMember :', error)
        dispatch({
          type: DELETE_MEMBER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateMember(member, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    firebase.child('members/' + member.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateMember :', error)
        dispatch({
          type: UPDATE_MEMBER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerMembersListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('members')
    ref.on('child_added', snapshot =>
      dispatch({
        type: CREATE_MEMBER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_changed', snapshot => {
      const member = recordFromSnapshot(snapshot)
      const { currentMember } = getState()
      dispatch({
        type: UPDATE_MEMBER_SUCCESS,
        payload: member
      })
      if (currentMember.member && member.key === currentMember.member.key) {
        return dispatch({
          type: INIT_MEMBER,
          payload: member,
          previous: member
        })
      }
    })

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_MEMBER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createMember,
  updateMember,
  registerMembersListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_MEMBER_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(member => member.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_MEMBER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_MEMBER_SUCCESS]: (state, action) => {
    return Object.assign({}, state, {
      list: state.list.map(member => {
        return member.key === action.payload.key ? action.payload : member
      })
    })
  },
  [UPDATE_MEMBER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_MEMBER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(member => {
        return member.key !== action.payload.key
      })
    }),
  [DELETE_MEMBER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_MEMBER]: (state, action) =>
    Object.assign({}, state, { selectedMember: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedMember: {} }
export default function membersReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/member.js